import type { PMIssue } from "@/domains/pm/types";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { cn } from "@/lib/utils";

/** Drawn where an issue shows its "#N": a draft has no number until it is saved. */
export function DraftIssueMarker({
  saving = false,
  className,
}: {
  saving?: boolean;
  className?: string;
}) {
  const { t } = useLanguage();
  return (
    <span
      data-draft-marker
      className={cn(
        "inline-flex shrink-0 items-center rounded-full bg-primary/10 px-1.5 text-[10px] font-semibold leading-4 text-primary",
        saving && "animate-pulse",
        className
      )}
    >
      {saving ? t.pm.issues.draft.saving : t.pm.issues.draft.marker}
    </span>
  );
}

/** A draft's title, or a muted stand-in while it has none. */
export function DraftIssueTitle({ issue, className }: { issue: PMIssue; className?: string }) {
  const { t } = useLanguage();
  const title = issue.title.trim();
  return title ? (
    <span className={className}>{issue.title}</span>
  ) : (
    <span className={cn(className, "italic text-muted-foreground")}>
      {t.pm.issues.draft.untitled}
    </span>
  );
}
